export default __webpack_public_path__ + "static/logo-ca19d16637709c6eab01213da1230298.png";